module.exports = [["Nov 14 17",4322,8.6],["Nov 15 17",6603,8.5],["Nov 16 17",14809,8],["Nov 17 17",23806,7.8],["Nov 18 17",44260,7.7],["Nov 19 17",58891,7.6],["Nov 20 17",71950,7.5],["Nov 21 17",79460,7.4],["Nov 22 17",85664,7.4],["Nov 23 17",91335,7.4],["Nov 24 17",95001,7.4],["Nov 25 17",100405,7.3]]


//////////////////
// WEBPACK FOOTER
// ./src/data/Justice League (2017) timeline.json
// module id = 502
// module chunks = 0